module.exports = __webpack_public_path__ + "static/media/womenStopViolence.08a386dd.png";